import styled from "@emotion/styled"

export const IconWrapper = styled.div<{color?: string, altColor?: string}>`
    &&& {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({color}) => color ? color : 'black'};
        padding: 15px;
        width: 15px;
        height: 15px;
        border-radius: 25px;
        cursor: pointer;
        margin: 5px;
    }

    &&&:hover {
        background-color: ${({altColor}) => altColor ? altColor : 'black'};
    }
`

export const IconContainer = styled.div`
    &&& {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
`

export const CenteredContainer = styled.div`
    &&& {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`
